import { createBrowserRouter, Navigate } from 'react-router';
import { useAuth } from './context/AuthContext';
import { Login } from './pages/Login';
import { Layout } from './components/Layout';
import { AdminDashboard } from './pages/AdminDashboard';
import { OperadorDashboard } from './pages/OperadorDashboard';
import { Usuarios } from './pages/Usuarios';
import { Empleados } from './pages/Empleados';
import { Agentes } from './pages/Agentes';
import { Otros } from './pages/Otros';
import { CierreAnterior } from './pages/CierreAnterior';
import { Tokens } from './pages/Tokens';

const ROLES = {
  ADMIN: 1,
  OPERADOR: 2,
};

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="text-center py-8">Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function RoleRoute({
  children,
  roles,
}: {
  children: React.ReactNode;
  roles: number[];
}) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="text-center py-8">Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!roles.includes(user.idRol)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

function withRole(element: React.ReactNode, roles: number[]) {
  return <RoleRoute roles={roles}>{element}</RoleRoute>;
}

function DashboardRouter() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  return user?.idRol === ROLES.ADMIN
    ? <AdminDashboard />
    : <OperadorDashboard />;
}

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <DashboardRouter />,
      },
      {
        path: 'usuarios',
        element: withRole(<Usuarios />, [ROLES.ADMIN]),
      },
      {
        path: 'empleados',
        element: withRole(<Empleados />, [ROLES.ADMIN]),
      },
      {
        path: 'agentes',
        element: withRole(<Agentes />, [ROLES.ADMIN]),
      },
      {
        path: 'otros',
        element: withRole(<Otros />, [ROLES.ADMIN]),
      },
      {
        path: 'tokens',
        element: withRole(<Tokens />, [ROLES.ADMIN]),
      },
      {
        path: 'cierreAnterior',
        element: withRole(<CierreAnterior />, [ROLES.OPERADOR]),
      },
    ],
  },
]);
